<template>
    <div class="flex-grid m-div-table__holder-section">
        <div class="flex-grid__g-2">
            <h3 class="heading">
                Type
            </h3>
            {{title}}
        </div>

        <div class="flex-grid__g-2">
            <h3 class="heading">Percentage</h3>
            <select v-model="userInterest" v-if="updates!=='generalDamages'">
                <option :value="0.5">0.50%</option>
                <option :value="0.25">0.25%</option>
            </select>
            <select v-model="userInterest" v-else disabled>
                <option :value="2">2.00%</option>
            </select>
        </div>

        <div class="flex-grid__g-3">
            <h3 class="heading">Value</h3>
            <control
                    :endpoint="endpoint"
                    :icon-space="theCurrentWidth < 1024 ? false : true"
                    :modal-name="'interest_' + uniqueId"
                    :payload="payload"
                    :option="option"
                    :table-control="true"
                    :tip-name="tipName"
                    before-after="pound"
                    label=""
                    tip-icon="formula"
                    tip-text="Click to view calculation" tip-side="left"
                    tip-width="140"
                    v-if="value > 0"
            >
                <input autocomplete="off" v-model="value" type="text" disabled v-two-dp>
            </control>
            <control v-if="parseFloat(value) === 0" label="" :table-control="true" tip-icon="default" before-after="pound">
                <input autocomplete="off" v-model="value" type="text" disabled v-two-dp>
            </control>
        </div>
    </div>
</template>

<script>
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Control from 'components/form/Control.vue';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'interest-item',
        components:{
            Control
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        props: {
            title: {
                type: String,
                required: true
            },
            value: {
                required: true
            },
            uniqueId: {
                required: true
            },
            interest: {
                type: Number,
                required: true
            },
            tipName: {
                type: String,
                required: true
            },
            updates: {
                required: true
            },
            endpoint: {
                type:String,
                default:'interest'
            },
            index: {
                default: null
            },
            payload: {
                default: null,
            },
            option: {
                type: Object,
                default: null,
            },
            name: {
                default: null,
            }
        },
        computed:{
            userInterest: {
                get() {
                    return this.interest;
                },
                set(value) {
                    return this.$emit('update', {
                        updates: this.updates,
                        value
                    });
                }
            },
            ...mapGetters('windowWidth', ['theCurrentWidth'])
        },
    }
</script>


// WEBPACK FOOTER //
// InterestItem.vue?a617c31a